import { GridColDef } from '@mui/x-data-grid';

import { SmsWidget } from '../../../DerivedCharts/helper';
import { renderCellFor } from '../../helper';
import { IPostgreCommunicationDTO } from '../../jobs/types/postgreJobsDTO';

interface SmsRow {
  recruiterName?: string;
  count?: number;
  jobTitle?: string;
  [key: string]: any;
}
export const getSmsTableData = (widgetName: SmsWidget, widgetData: IPostgreCommunicationDTO) => {
  const uniqueDates = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.countsByDate ?? {})))
  );

  let columns: GridColDef<SmsRow, any, any>[];
  switch (widgetName) {
    case SmsWidget.TABLE_SENT:
    case SmsWidget.TABLE_RECEIVED:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 2,
          minWidth: 170,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'count',
          headerName: `Total Count(${widgetData?.count ?? 0})`,
          flex: 1,
          minWidth: 150,
        },
        ...uniqueDates.map((date) => ({
          field: date,
          headerName: date,
          width: 120,
        })),
      ];
      break;
    case SmsWidget.TABLE_SENT_USER_ONLY:
    case SmsWidget.TABLE_RECEIVED_USER_ONLY:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 2,
          minWidth: 170,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'count',
          headerName: `Total Count(${widgetData?.count ?? 0})`,
          flex: 1,
          minWidth: 150,
        },
      ];
      break;
    case SmsWidget.TABLE_SENT_JOB:
    case SmsWidget.TABLE_RECEIVED_JOB:
      columns = [
        {
          field: 'jobTitle',
          headerName: 'Job Title',
          flex: 2,
          minWidth: 170,
        },
        {
          field: 'count',
          headerName: `Total Count(${widgetData?.count ?? 0})`,
          flex: 1,
          minWidth: 150,
        },
      ];
      break;
    default:
      throw new Error("Invalid 'SMS Table Widget' type");
  }

  widgetData?.resultSet?.forEach((record, index) => {
    record.id = index;
    uniqueDates.forEach((date) => {
      record[date] = record?.countsByDate?.[date] || 0;
    });
  });

  return [widgetData?.resultSet, columns];
};

export const defaultSmsWidgetData: IPostgreCommunicationDTO = {
  totalCount: 0,
  totalReceived: 0,
  totalSent: 0,
  response: [],
  resultSet: [],
  series: [],
  categories: [],
};
